export default __webpack_public_path__ + "static/Informacna_povinnost_na_web_Autoskola_Hron-efb33561c29433ee2ecd14f0971f09f8.pdf";